export const FETCH_ALERT_REQUEST = "FETCH_ALERT_REQUEST";
export const FETCH_ALERT_SUCCESS = "FETCH_ALERT_SUCCESS";
export const FETCH_ALERT_FAILURE = "FETCH_ALERT_FAILURE";